import React from "react";

const ThemedTable = ({ children, className = "" }) => {
  // Use React.Children.map to safely iterate over children, handling nulls/undefined
  const styledChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;

    // Check for thead
    if (child.type === "thead") {
      return (
        <thead {...child.props}>
          {React.Children.map(child.props.children, (tr) => {
            if (!React.isValidElement(tr)) return tr;

            return React.cloneElement(tr, {
              children: React.Children.map(tr.props.children, (th) => {
                if (!React.isValidElement(th) || th.type !== "th") return th;

                return React.cloneElement(th, {
                  className:
                    "text-left px-4 py-3 text-sm font-semibold text-white bg-[#172554] " +
                    (th.props.className || ""),
                });
              }),
            });
          })}
        </thead>
      );
    }

    // Check for tbody
    if (child.type === "tbody") {
      return (
        <tbody {...child.props}>
          {React.Children.map(child.props.children, (tr) => {
            if (!React.isValidElement(tr)) return tr;
            if (tr.type === React.Fragment) return tr; // Skip styling Fragments directly

            if (tr.type !== "tr") return tr;

            return React.cloneElement(tr, {
              className:
                "border-b border-slate-200 hover:bg-slate-50 " +
                (tr.props.className || ""),
              children: React.Children.map(tr.props.children, (td) => {
                if (!React.isValidElement(td) || td.type !== "td") return td;

                return React.cloneElement(td, {
                  className:
                    "px-4 py-3 text-sm text-slate-700 " +
                    (td.props.className || ""),
                });
              }),
            });
          })}
        </tbody>
      );
    }

    return child;
  });

  return (
    <table className={`w-full border-collapse ${className}`}>
      {styledChildren}
    </table>
  );
};

export default ThemedTable;
